import { z } from "zod";
import { UploadContextType } from "./upload-context.js";
const IMAGE_CONTENT_TYPES = ["image/png", "image/jpeg"];
const PDF_CONTENT_TYPE = "application/pdf";
const ALL_CONTENT_TYPES = [...IMAGE_CONTENT_TYPES, PDF_CONTENT_TYPE];
const IMAGE_ONLY_CONTEXTS = [UploadContextType.CONTRACT, UploadContextType.PROPERTY];
const PNG_ONLY_CONTEXTS = [UploadContextType.USER];
const PDF_ONLY_CONTEXTS = [UploadContextType.OWNER_DOCUMENT];
export const MAX_UPLOAD_SIZE_BYTES = 10 * 1024 * 1024;
const uploadContextSchema = z.object({
    type: z.enum(Object.values(UploadContextType)),
    entity_id: z.uuid({ message: "Entity ID must be a valid UUID" }).optional(),
});
export const presignUploadSchema = z
    .object({
    file_name: z.string().min(1, { message: "File name is required" }),
    content_type: z.enum(ALL_CONTENT_TYPES, {
        message: "Only PNG, JPEG and PDF files are allowed",
    }),
    size: z
        .number()
        .positive({ message: "File size must be positive" })
        .max(MAX_UPLOAD_SIZE_BYTES, { message: "File size must not exceed 10 MB" }),
    context: uploadContextSchema,
})
    .strict()
    .refine((data) => {
    return !!data.context.entity_id;
}, { message: "Entity ID is required for this upload context", path: ["context", "entity_id"] })
    .refine((data) => {
    if (PDF_ONLY_CONTEXTS.includes(data.context.type)) {
        return data.content_type === PDF_CONTENT_TYPE;
    }
    if (PNG_ONLY_CONTEXTS.includes(data.context.type)) {
        return data.content_type === "image/png";
    }
    if (IMAGE_ONLY_CONTEXTS.includes(data.context.type)) {
        return IMAGE_CONTENT_TYPES.includes(data.content_type);
    }
    return true;
}, { message: "Content type is not allowed for this upload context", path: ["content_type"] });
export const presignBatchUploadSchema = z
    .array(presignUploadSchema)
    .min(1, { message: "At least one file is required" })
    .max(6, { message: "Maximum 6 files per batch" });
